module.exports = __webpack_public_path__ + "static/img/6_nipish.26084dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enemies/6_nipish.png
// module id = iW7v
// module chunks = 1